setTimeout(() => {
    document.querySelector(".v5-intelligent-choose-entrance jds-button") && document.querySelector(".v5-intelligent-choose-entrance jds-button").addEventListener('click', function(){
        const title = this.parentElement.parentElement.querySelector(".blocks-heading-content .blocks-content-subheading .hidden p").textContent;
        const spuNames = document.querySelectorAll(".v5-product-info-wrapper h1 span");
        let spuName = '';
        if (spuNames.length !== 0) {
            spuName = spuNames[0].textContent + " " + spuNames[1].textContent;
        }
        const event_parameters = {
            "module": title,
            "product_spu_name": spuName,
            "button_name": this.textContent
        }
        gaPushDataLayer("5.0_products_details_page_user_clicks", event_parameters);
    });
}, 20);